 export const data = [
  {
    id: 1,
    title: "Aquarius",
    date: "(January 20 - February 18)",
    desc: "Despite the 'aqua' in its name, Aquarius is actually the last air sign of the zodiac. Innovative, progressive, and shamelessly revolutionary, Aquarius is represented by the water bearer, the mystical healer who bestows water, or life, upon the land. Accordingly, Aquarius is the most humanitarian astrological sign. At the end of the day, Aquarius is dedicated to making the world a better place.",
    image:
      "https://drscdn.500px.org/photo/1049427126/q%3D80_m%3D2000/v2?sig=98f779475524b162f09c3859e9a7f60b676c244342ad0888c0cc1270482c941a",
  },
  {
    id: 2,
    title: "Pisces",
    date: "(February 19 - March 20)",
    desc: "If you looked up the word 'psychic' in the dictionary, there would definitely be a picture of Pisces next to it. Pisces is the most intuitive, sensitive, and empathetic sign of the entire zodiac — and that’s because it’s the last of the last. As the final sign, Pisces has absorbed every lesson — the joys and the pain, the hopes and the fears — learned by all of the other signs. It's symbolized by two fish swimming in opposite directions, representing the constant division of Pisces' attention between fantasy and reality.",
    image:
      "https://drscdn.500px.org/photo/133570805/q%3D80_m%3D2000/v2?sig=bb1629ac72814ee2d470f0f1551992ea2b0d72acac4e81af5b76aed5c9e99020",
  },
  {
    id: 3,
    title: "Aries",
    date: "(March 21 - April 19)",
    desc: "The first sign of the zodiac, Aries loves to be number one. Naturally, this dynamic fire sign is no stranger to competition. Bold and ambitious, Aries dives headfirst into even the most challenging situations—and they'll make sure they always come out on top!",
    image:
      "https://drscdn.500px.org/photo/31012403/q%3D80_m%3D2000/v2?sig=9f5fb2a1796aa6243534d92cf4f81ff5d2da01e7d63aad4bb69fa513a4b875d8",
  },
  {
    id: 4,
    title: "Taurus",
    date: "(April 20 - May 20)",
    desc: "What sign is more likely to take a six-hour bath, followed by a luxurious Swedish massage and decadent dessert spread? Why Taurus, of course! Taurus is an earth sign represented by the bull. Like their celestial spirit animal, Taureans enjoy relaxing in serene, bucolic environments surrounded by soft sounds, soothing aromas, and succulent flavors.",
    image:
      "https://drscdn.500px.org/photo/204834197/q%3D80_m%3D2000/v2?sig=425f7d2e62c02e4d05de04d9f9fe8860de980fb7ff21bffac85c58c6f3ca436e",
  },
  {
    id: 5,
    title: "Gemini",
    date: "(May 21 - June 20)",
    desc: "Have you ever been so busy that you wished you could clone yourself just to get everything done? That's the Gemini experience in a nutshell. Spontaneous, playful, and adorably erratic, Gemini is driven by its insatiable curiosity. Appropriately symbolized by the celestial twins, this air sign was interested in so many pursuits that it had to double itself. You know, NBD!",
    image:
      "https://drscdn.500px.org/photo/71440209/q%3D80_m%3D2000/v2?sig=638b89703e31abd61ba0dd31d64f9498705aae3e8e5a93a2d1f13f8137815136",
  },
  {
    id: 6,
    title: "Cancer",
    date: "(June 21 - July 22)",
    desc: "Represented by the crab, Cancer seamlessly weaves between the sea and shore representing Cancer’s ability to exist in both emotional and material realms. Cancers are highly intuitive and their psychic abilities manifest in tangible spaces. But—just like the hard-shelled crustaceans—this water sign is willing to do whatever it takes to protect itself emotionally. In order to get to know this sign, you're going to need to establish trust! ",
    image:
      "https://drscdn.500px.org/photo/287869427/q%3D80_m%3D2000/v2?sig=1d78fc6942376de5eca0f0b7a08ff0ce2bf3aed9c70dce6d035c7451809926ee",
  },
  {
    id: 7,
    title: "Leo",
    date: "(July 23 - August 22)",
    desc: "Roll out the red carpet because Leo has arrived. Passionate, loyal, and infamously dramatic, Leo is represented by the lion and these spirited fire signs are the kings and queens of the celestial jungle. They're delighted to embrace their royal status: Vivacious, theatrical, and fiery, Leos love to bask in the spotlight and celebrate… well, themselves.",
    image:
      "https://drscdn.500px.org/photo/68303317/q%3D80_m%3D2000/v2?sig=3a2f9aec5a2276090f6e3245b30a7d9e8d65008beb346d38e2ec77386483056d",
  },
  {
    id: 8,
    title: "Virgo",
    date: "(August 23 - September 22)",
    desc: "You know the expression, 'if you want something done, give it to a busy person?' Well, that definitely is the Virgo anthem. Virgos are logical, practical, and systematic in their approach to life. Virgo is an earth sign historically represented by the goddess of wheat and agriculture, an association that speaks to Virgo's deep-rooted presence in the material world. This earth sign is a perfectionist at heart and isn’t afraid to improve skills through diligent and consistent practice.",
    image:
      "https://drscdn.500px.org/photo/143526715/q%3D80_m%3D2000/v2?sig=3e011bec823ee229dec5a7dc30e79b513618fbc1db5acd0a1eccdc14fed4b32b",
  },
  {
    id: 9,
    title: "Libra",
    date: "(September 23 - October 22)",
    desc: "Balance, harmony, and justice define Libra energy. As a cardinal air sign, Libra is represented by the scales (interestingly, the only inanimate object of the zodiac), an association that reflects Libra's fixation on establishing equilibrium. Libra is obsessed with symmetry and strives to create equilibrium in all areas of life — especially when it comes to matters of the heart.",
    image:
      "https://drscdn.500px.org/photo/1057393816/q%3D80_m%3D2000/v2?sig=7e65c50061ef25723ed9ffaee7c70db2b25f273815994947d0c635796b09e070",
  },
  {
    id: 10,
    title: "Scorpio",
    date: "(October 23 - November 21)",
    desc: "Elusive and mysterious, Scorpio is one of the most misunderstood signs of the zodiac. Scorpio is a water sign that uses emotional energy as fuel, cultivating powerful wisdom through both the physical and unseen realms. In fact, Scorpio derives its extraordinary courage from its psychic abilities, which is what makes this sign one of the most complicated, dynamic signs of the zodiac",
    image:
      "https://drscdn.500px.org/photo/1058508757/q%3D80_m%3D2000_k%3D1/v2?sig=e7d24d769ebb5f03ae9ccd24ce3493a1e014fffc9515f5430284ca5d5f425435",
  },
  {
    id: 11,
    title: "Sagittarius",
    date: "(November 22 - December 21)",
    desc: "Oh, the places Sagittarius goes! But… actually. This fire sign knows no bounds. Represented by the archer, Sagittarians are always on a quest for knowledge. The last fire sign of the zodiac, Sagittarius launches its many pursuits like blazing arrows, chasing after geographical,.",
    image:
      "https://drscdn.500px.org/photo/245435019/q%3D80_m%3D2000/v2?sig=5d261f85136e73aa35e51640738d6d25b4f997078e27055b7972780466e5c0dd",
  },
  {
    id: 12,
    title: "Capricorn",
    date: "(December 22 - January 19)",
    desc: "What is the most valuable resource? For Capricorn, the answer is clear: Time. Capricorn is climbing the mountain straight to the top and knows that patience, perseverance, and dedication is the only way to scale. The last earth sign of the zodiac, Capricorn, is represented by the sea-goat, a mythological creature with the body of a goat and the tail of a fish. Accordingly, Capricorns are skilled at navigating both the material and emotional realms.",
    image:
      "https://drscdn.500px.org/photo/177900201/q%3D80_m%3D2000/v2?sig=611a2974d3d1b4d149199543eec296460202286459e4ffef81af93d752713c8b",
  },
];
